import type { EmailEventDto, EmailLogPageDto } from "@tc/shared";

/**
 * Email-log data access (TRAV-59) — back-office only. The list is server-paginated (newest
 * first) and optionally club-scoped; the per-message HTML is not fetched here at all — rows link
 * straight to `GET /api/email-log/:id/html`, which serves the stored body as a page.
 */
const API_URL = import.meta.env.VITE_API_URL ?? "/api";

export async function listEmailLog(page: number, clubId?: string): Promise<EmailLogPageDto> {
  const params = new URLSearchParams({ page: String(page) });
  if (clubId) params.set("clubId", clubId);
  const res = await fetch(`${API_URL}/email-log?${params}`, { headers: { accept: "application/json" } });
  if (!res.ok) throw new Error(`Email log request failed (${res.status})`);
  return (await res.json()) as EmailLogPageDto;
}

/** SES event history for one message (TRAV-61), oldest first — backs the status-badge modal. */
export async function listEmailEvents(id: string): Promise<EmailEventDto[]> {
  const res = await fetch(`${API_URL}/email-log/${id}/events`, { headers: { accept: "application/json" } });
  if (!res.ok) throw new Error(`Email events request failed (${res.status})`);
  return (await res.json()) as EmailEventDto[];
}

/** The same-origin URL a row links to (new tab; the session cookie rides along). */
export function emailHtmlUrl(id: string): string {
  return `${API_URL}/email-log/${id}/html`;
}
